import { ActionTypes } from "../../actions/types";
import { PROBING_SET_STATUS, PROBING_SET_LOADING } from "../../actions";

export interface ProbingStatusState {
    active: boolean;
    questionIdsNeedingProbes: string[];
    isLoading: boolean;
}

const initialState: ProbingStatusState = {
    active: false,
    questionIdsNeedingProbes: [],
    isLoading: false
};

export const probingStatusSliceReducer = (
    state: ProbingStatusState = initialState,
    action: ActionTypes
): ProbingStatusState => {
    switch (action.type) {
        case PROBING_SET_STATUS: {
            const { isActive, pendingQuestionIds = [] } = action.payload;
            
            return {
                ...state,
                active: isActive,
                questionIdsNeedingProbes: pendingQuestionIds
            };
        }
        
        case PROBING_SET_LOADING: {
            return {
                ...state,
                isLoading: action.isLoading
            };
        }
        
        default:
            return state;
    }
}; 